import { BaseApi, HttpMethodEnum } from '../BaseApi/BaseApi';
import {
    IPrescription,
    IPrescriptionActivityEvent,
    IUnlockPrescriptionsRequest,
    IValidatePrescriptionsRequest,
    PrescriptionData,
} from '../../entities/Prescription/Prescription.ts';

export class PrescriptionApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/Prescriptions`;

    public static apiUrls = {
        getPrescriptions: `${BaseApi.apiUrl}/Patients/:id/Prescriptions`,
        putPrescription: `${BaseApi.apiUrl}/Patients/:id/Prescriptions`,
        deletePrescription: `${PrescriptionApi.baseApiUrl}/:id`,
        validate: `${PrescriptionApi.baseApiUrl}/Validate`,
        unlock: `${PrescriptionApi.baseApiUrl}/Unlock`,
        activityHistory: `${BaseApi.apiUrl}/Patients/:id/Prescriptions/ActivityHistory`,
        pdf: `${BaseApi.apiUrl}/Patients/:id/Prescriptions/pdf`,
        sendToAssistant: `${BaseApi.apiUrl}/Patients/:id/Prescriptions/SendToAssistant`,
    };

    public static async getPrescriptions(id: string): Promise<PrescriptionData> {
        return this.sendApiRequest<PrescriptionData>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getPrescriptions,
            data: undefined,
            id: id,
        });
    }

    public static async putPrescription(id: string, data: IPrescription[]): Promise<number> {
        return this.sendApiRequest<number>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.putPrescription,
            data: data,
            id: id,
        });
    }

    public static async deletePrescription(id: string): Promise<void> {
        return this.sendApiRequest<void>({
            method: HttpMethodEnum.DELETE,
            path: this.apiUrls.deletePrescription,
            data: undefined,
            id: id,
        });
    }

    public static async validatePrescriptions(request: IValidatePrescriptionsRequest): Promise<PrescriptionData> {
        return this.sendApiRequest<PrescriptionData>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.validate,
            data: request as any,
        });
    }

    public static async unlockPrescriptions(request: IUnlockPrescriptionsRequest): Promise<PrescriptionData> {
        return this.sendApiRequest<PrescriptionData>({
            method: HttpMethodEnum.POST,
            path: this.apiUrls.unlock,
            data: request as any,
        });
    }

    public static async getActivityHistory(patientId: string): Promise<IPrescriptionActivityEvent[]> {
        return this.sendApiRequest<IPrescriptionActivityEvent[]>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.activityHistory,
            data: undefined,
            id: patientId,
        });
    }

    public static async downloadPrescriptionsPdf(patientId: string, language: string): Promise<Blob> {
        return this.sendApiRequest<Blob>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.pdf}?language=${language}`,
            data: undefined,
            id: patientId,
            extraOptionsConfig: { responseType: 'blob' },
        });
    }

    public static async sendPrescriptionsToAssistant(
        patientId: string,
        language: string,
    ): Promise<{ assistantName: string; assistantEmail: string }> {
        return this.sendApiRequest<{ assistantName: string; assistantEmail: string }>({
            method: HttpMethodEnum.POST,
            path: `${this.apiUrls.sendToAssistant}?language=${language}`,
            data: undefined,
            id: patientId,
        });
    }

    public static downloadPdfFile(pdfBlob: Blob, filename?: string): void {
        const url = window.URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename || `Prescriptions_${new Date().toISOString().split('T')[0]}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
}
